<template>
  <div class="index">
    <headd :index_show="indexshow"></headd>
    <indexswiper :swiper_list="swiper_list"></indexswiper>
    <indexicon :icon_list="icon_list"></indexicon>
    <!-- <indexnotice :notice_list="notice_list"></indexnotice> -->
    <indexbanner :adbannerlist="banner_1"></indexbanner>
    <indexwelfare :welfare_list="welfare_list"></indexwelfare>
    <indexrecommend :recommend_list="listTemp"></indexrecommend>
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="video_item" v-for="item in videos">
            <div class="container-head">
              <div class="head-left">
                <div class="icon">
                  <img src="../../.../../static/index/video/v_icon_1.png" />
                </div>
                每日财税课堂
              </div>
              <div class="head-right" @click="govideourl('cs')">
                查看更多
                <div class="icon"></div>
              </div>
            </div>
            <div
              class="root"
              @click="govideo(item.videopath, item.photopath)"
              :style="{ backgroundImage: 'url(' + item.photopath + ')' }"
            >
              <img class="posterImg" :src="item.photopath" mode="aspectFit" />
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="video_item" v-for="item in fwvideos">
            <div class="container-head">
              <div class="head-left">
                <div class="icon">
                  <img src="../../.../../static/index/video/v_icon_1.png" />
                </div>
                每日法务课堂
              </div>
              <div class="head-right" @click="govideourl('fw')">
                查看更多
                <div class="icon"></div>
              </div>
            </div>

            <div
              class="root"
              @click="govideo(item.videopath, item.photopath)"
              :style="{ backgroundImage: 'url(' + item.photopath + ')' }"
            >
              <img class="posterImg" :src="item.photopath" mode="aspectFit" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container ad" @click="goaffairs">
      <img :src="fwkv.pagevaluepc" class="hidden-xs" />
      <img :src="fwkv.pagevalue" class="hidden-lg hidden-md hidden-sm" />
    </div>

    <indexnews
      @itemClick="goDetail"
      :news_list="news_list"
      :newlistTemp="newlistTemp"
    ></indexnews>
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-xs-12">
          <indexnewly :newly="booticon1"></indexnewly>
        </div>
        <div class="col-lg-6 col-xs-12">
          <indexmanage :manage="booticon2"></indexmanage>
        </div>
      </div>
    </div>
    <indextel :solgan="solgan" :num="dy_title_t1" :service="service"></indextel>

    <div class="index-aboutus container">
      <div class="container-head">
        <div class="head-left">
          <div class="icon">
            <img src="../../static/index/aboutus/aboutus-icon.png" />
          </div>
          关于我们
        </div>
      </div>
      <div class="aboutus">
        <div class="aboutus-banner">
          <indexbanner
            :adbannerlist="banner_2"
            :config="config_2"
          ></indexbanner>
        </div>
        <div class="aboutus-icon">
          <div class="aboutus-item" @click="kefu">
            <div class="item-icon">
              <img src="../../static/index/aboutus/icon-1.png" />
            </div>
            <div class="item-name">联系客服</div>
          </div>
          <div class="aboutus-item" @click="gosugget()">
            <div class="item-icon">
              <img src="../../static/index/aboutus/icon-2.png" />
            </div>
            <div class="item-name">投诉建议</div>
          </div>
          <div class="aboutus-item" @click="goinfo()">
            <div class="item-icon">
              <img src="../../static/index/aboutus/icon-3.png" />
            </div>
            <div class="item-name">企业信息</div>
          </div>
          <div class="aboutus-item" @click="wxqr">
            <div class="item-icon">
              <img src="../../static/index/aboutus/icon-4.png" />
            </div>
            <div class="item-name">微信公众号</div>
          </div>
        </div>
        <div class="aboutus-tel">
          <div class="tel-icon"></div>
          <div class="tel-text">电话联系 021-58390061</div>
        </div>
        <div class="links">
          <div class="links_title">友情链接</div>
          <div class="links_list">
            <a
              v-for="item in frlink"
              :key="item.id"
              :href="item.linkpath"
              target="_blank"
              >{{ item.title }}</a
            >
          </div>
        </div>
        <div class="copyright">
          <span
            >Copyright 2019-2021 上海广筑信息技术有限公司 版权所有
            <!-- 沪ICP备 XXXXXXXX 软件著作版号 XXXXXXX --></span
          >
        </div>
      </div>
    </div>
    <el-dialog title="" :visible.sync="dialogFormVisible_2" width="4rem">
      <div class="common_poup">
        <img class="qr_img" src="../../static/wxqr.jpg" />
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="dialogFormVisible" width="6rem">
      <suggestion
        :www="www"
        :apiurl="apiurl"
        @suggclose="updateclose"
      ></suggestion>
    </el-dialog>

    <el-dialog title="" :visible.sync="dialogFormVisible_3" width="7.5rem">
      <div class="video_open">
        <video :src="video_url" controls autoplay="autoplay"></video>
      </div>
    </el-dialog>
    <foot></foot>
  </div>
</template>
<script>
import {
  getBanners,
  getnews,
  getwelfarelist,
  getTuijian,
  getBooticon,
  getappads,
  getkefuchannel,
  getindexPageData,
  getfriendlinks,
  getindexfwvideos,
  getindexcsvideos,
  getindexmsgnum
} from "./api/api"; //引入api里面定义的方法
import indexswiper from "../components/indexswiper";
import indexicon from "../components/indexicon";
import indexnotice from "../components/indexnotice";
import indexwelfare from "../components/indexwelfare";
import indexrecommend from "../components/indexrecommend";
import indexnewly from "../components/indexnewly";
import indexbanner from "../components/indexbanner";
import indexmanage from "../components/indexmanage";
import indexnews from "../components/indexnews";
import suggestion from "../components/suggestion";
import headd from "../components/head";
import foot from "@/components/foot";
import indextel from "../components/indextel.vue";
export default {
  data() {
    return {
      indexshow: true,
      dialogFormVisible: false,
      dialogFormVisible_2: false,
      dialogFormVisible_3: false,
      www: this.common.www_img,
      apiurl: this.common.apiurl,
      dy_title_t1: "",
      fwkv: "",
      videos: [],
      fwvideos: [],
      icon_list: [
        {
          id: 1,
          icon_image: require("../../static/index/icon/icon-1.png"),
          name: "公司注册"
        },
        {
          id: 2,
          icon_image: require("../../static/index/icon/icon-2.png"),
          name: "代理记账"
        },
        {
          id: 3,
          icon_image: require("../../static/index/icon/icon-3.png"),
          name: "商标注册"
        },
        {
          id: 4,
          icon_image: require("../../static/index/icon/icon-4.png"),
          name: "知识产权"
        },
        {
          id: 5,
          icon_image: require("../../static/index/icon/icon-5.png"),
          name: "许可证办理"
        },
        {
          id: 6,
          icon_image: require("../../static/index/icon/icon-6.png"),
          name: "公司服务"
        },
        {
          id: 7,
          icon_image: require("../../static/index/icon/icon-7.png"),
          name: "资讯"
        },
        {
          id: 8,
          icon_image: require("../../static/index/icon/icon-8.png"),
          name: "医疗器械许可"
        }
      ],
      welfare_list: [],
      recommend_list: [],
      swiper_list: [],
      frlink: [],
      adbannerlist: [
        {
          id: 1,
          img: require("../../static/index/banner/banner-2.png"),
          url: "http://www.baidu.com"
        }
      ],
      news_list: [],
      booticon1: [],
      booticon2: [],
      banner_1: [],
      banner_2: [],
      config_1: true,
      config_2: false,
      solgan: "我需要法律顾问服务",
      service: "首页咨询",
      video_url: "",
      indexmsgnum: 0
    };
  },
  watch: {
    dialogFormVisible_3(val, oldval) {
      if (!val) {
        this.video_url = "";
      }
    }
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    indexicon,
    indexnotice,
    indexwelfare,
    indexrecommend,
    indexnewly,
    indexswiper,
    indexbanner,
    indexmanage,
    indexnews,
    suggestion,
    headd,
    indextel,
    foot
  },
  computed: {
    listTemp: function() {
      let index = 0;
      let count = window.innerWidth > 1000 ? 8 : 4;
      let arrTemp = [];
      let experts = this.recommend_list;
      for (let i = 0; i < this.recommend_list.length; i++) {
        index = parseInt(i / count);
        if (arrTemp.length <= index) {
          arrTemp.push([]);
        }
        arrTemp[index].push(experts[i]);
      }
      return arrTemp;
    },
    newlistTemp: function() {
      let index = 0;
      let count = 3;
      let arrTemp = [];
      let experts = this.news_list;
      for (let i = 0; i < this.news_list.length; i++) {
        index = parseInt(i / count);
        if (arrTemp.length <= index) {
          arrTemp.push([]);
        }
        arrTemp[index].push(experts[i]);
      }
      return arrTemp;
    }
  },
  async mounted() {
    //console.log();
    if (this.$route.query.openid) {
      localStorage.setItem("openid", this.$route.query.openid);
    }
    var swiperr = await getBanners();
    this.swiper_list = swiperr.data.data.banner;
    this.$nextTick(function() {
      this.swiper();
    });

    var indexfw = await getindexfwvideos();
    this.fwvideos = indexfw.data.data.fwvideos;

    var indexcs = await getindexcsvideos();
    this.videos = indexcs.data.data.csvideos;

    var frlin = await getfriendlinks();
    this.frlink = frlin.data.data.friendlinks;

    var news = await getnews();
    this.news_list = news.data.data.indexzixun;
    this.$nextTick(() => {
      new Swiper(".news", {
        loop: true,
        observer: true,
        // 如果需要分页器
        pagination: ".news .swiper-pagination",
        autoplay: 5000
      });
      new Swiper(".pcnews", {
        loop: true,
        observer: true,
        // 如果需要分页器
        paginationClickable: true,
        pagination: ".pcnews .swiper-pagination",
        autoplay: 5000
      });
    });

    var indexpage = await getindexPageData();
    this.dy_title_t1 = indexpage.data.data.t1;
    this.fwkv = indexpage.data.data.fwkv;

    var welfare = await getwelfarelist();
    this.welfare_list = welfare.data.data.coupons;

    var tuijian = await getTuijian();
    this.recommend_list = tuijian.data.data.indexTjCombo;
    this.$nextTick(function() {
      this.swiper_tuijian();
    });

    var Booticon = await getBooticon();
    this.booticon1 = Booticon.data.data.icons1.reverse();
    this.booticon2 = Booticon.data.data.icons2.reverse();

    var appads1 = await getappads("index_ads1");
    this.banner_1 = appads1.data.data.appads;

    var appads2 = await getappads("index_ads2");
    this.banner_2 = appads2.data.data.appads;
  },

  methods: {
    swiper() {
      new Swiper(".banner", {
        loop: true,
        observer: true,
        pagination: ".swiper-pagination",
        paginationClickable: true,
        autoplay: 5000
      });
    },
    swiper_tuijian() {
      new Swiper(".tuijian", {
        //loop: true,
        observer: true,
        pagination: ".swiper-pagination",
        paginationClickable: true,
        autoplay: 5000,
        slidesPerView: 1
      });
    },
    goaffairs() {
      this.$router.push({
        path: "affairs"
      });
    },
    govideourl(type) {
      if (type == "cs") {
        this.$router.push({
          path: "videolist"
        });
      }
      if (type == "fw") {
        this.$router.push({
          path: "videolistfw"
        });
      }
    },
    govideo(url, img_url) {
      //console.log(url)
      this.video_url = url;
      //this.dialogFormVisible_3 = true;
      this.$router.push({
        name: "videoplay",
        params: {
          url: url,
          img_url: img_url
        }
      });
    },
    goDetail(id, is_ad) {
      if (is_ad === 1) return false;
      this.$router.push({
        name: "newsdetail",
        params: {
          id: id
        }
      });
    },
    goinfo() {
      this.$router.push({
        path: "companyinfo"
      });
    },
    gosugget() {
      this.dialogFormVisible = true;
    },
    updateclose(data) {
      console.log(data);
      this.dialogFormVisible = data.dialog; //改变了父组件的值
    },
    wxqr() {
      this.dialogFormVisible_2 = true;
    },
    async kefu() {
      var _self = this;
      var data = {
        uid: localStorage.getItem("userId")
      };
      const res = await getkefuchannel(data);
      console.log(res);
      if (res.data.status == 1) {
        //_self.kfid = res.data.data.kfid

        var uid = localStorage.getItem("userId");
        var recipient_id = res.data.data.kfid;

        const url = this.$router.resolve({
          path: "/chat",
          query: { uid: uid, recipient_id: recipient_id }
        });
        window.open(url.href, "_blank");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.contation {
  width: 100%;
}
.container {
  padding: 0 0.15rem;
  @media (max-width: 991px) {
    padding: 0 0rem;
  }
}
.index {
  @media (max-width: 991px) {
    width: 6.84rem;
  }
  margin: auto;
  .index-aboutus {
    flex-direction: column;
    margin: auto;

    .aboutus {
      flex-direction: column;
      display: flex;
      .aboutus-banner {
        width: 100%;
        margin-bottom: 0.4rem;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .aboutus-icon {
        flex-direction: row;
        justify-content: space-around;
        margin-bottom: 0.4rem;
        display: flex;
        .aboutus-item {
          cursor: pointer;
          justify-content: center;
          flex-direction: column;

          .item-icon {
            width: 0.5rem;
            height: 0.5rem;
            margin: 0 auto 0.2rem auto;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .item-name {
            font-size: 0.2rem;
            line-height: 0.28rem;
            color: #8d8e99;
          }
        }
      }

      .aboutus-tel {
        margin: 0 auto 0.6rem auto;
        width: 3.87rem;
        height: 0.62rem;
        border: 0.02rem solid #1395ff;
        border-radius: 0.5rem;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        display: flex;

        .tel-icon {
          width: 0.3rem;
          height: 0.36rem;
          background: url(../../static/index/aboutus/tel-icon.png) no-repeat;
          background-size: 100%;
          margin-right: 0.2rem;
        }

        .tel-text {
          color: #1395ff;
          font-size: 0.18rem;
          @media (max-width: 991px) {
            font-size: 0.28rem;
          }
        }
      }
      .links {
        margin-bottom: 0.6rem;
        .links_title {
          font-size: 0.3rem;
          line-height: 0.42rem;
          margin-bottom: 0.3rem;
        }
        .links_list {
          display: flex;
          flex-flow: wrap;
          justify-content: flex-start;
          a {
            font-size: 0.18rem;
            line-height: 0.25rem;
            color: #5e5e66;
            margin-right: 0.2rem;
            margin-bottom: 0.2rem;
            @media (max-width: 991px) {
              font-size: 0.26rem;
              line-height: 0.3rem;
            }
          }
          &::after {
          }
        }
      }

      .copyright {
        margin: 0 auto 0.3rem auto;
        text-align: center;
        font-size: 0.2rem;
        line-height: 0.32rem;
        color: #c4c4cc;
        @media (max-width: 991px) {
          font-size: 0.26rem;
        }
      }
    }
  }
}
.common_poup {
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 0;

  flex-direction: column;
  align-items: center;
  justify-content: center;

  .qr_img {
    width: 100%;
    //height: 3.6rem;
    margin-bottom: 0rpx;
  }

  .qr_tip {
    font-size: 0.26rem;
    line-height: 0.42rem;
    text-align: center;
  }
}
.video_item {
  margin: 0 0rem;
  flex-direction: column;
  //   .root {
  //     width: 100;
  //     height: auto;
  //     img {
  //       width: 100%;
  //     }
  //   }
  .root {
    width: 100%;
    height: 3.2rem;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
      opacity: 0;
      position: relative;
    }
  }
}
.ad {
  margin-top: 0.6rem;
  img {
    width: 100%;
  }
}
.video_open {
  video {
    width: 100%;
  }
}
@media (max-width: 991px) {
  .head_line {
    border-bottom: 0rem solid #ccc;
    padding-bottom: 0rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue